import styled, {css} from 'styled-components';
import {OptionProps, OptionVariant} from './types';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';

export const Wrapper = styled.div<Pick<OptionProps, 'variant'>>`
  overflow: hidden;
  margin-right: 6px;
  margin-bottom: 6px;
  padding-left: 10px;
  border-radius: 5px;
  box-sizing: border-box;

  word-break: break-word;
  column-gap: 4px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
  
  ${({variant, theme}) => {
    switch (variant) {
      case OptionVariant.Default: return css`
        background: ${transparentize(.9, theme.colors.white)};
      `;
      case OptionVariant.Primary: return css`
        background: ${theme.colors.primary};
      `;
    }
  }};
  
  font-size: 12px;
  line-height: 16px;
`;

export const Label = styled.span`
  padding: 6px 0;
`;

export const Remove = styled.button`
  ${transition()};
  padding: 0 10px;
  height: 100%;
  
  &:hover {
    background: ${({theme}) => `
      ${transparentize(.9, theme.colors.white)};
    `};
    
    &:active {
      background: ${({theme}) => `
        ${transparentize(.6, theme.colors.white)};
      `};
    }
  }
`;
